"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    background: linear-gradient(to right, #0e0e0e 0%, #6b6b6b 100%);

    .card-callout-inner-container {
        display: flex;
        flex-wrap: wrap;
        padding: 1em 1em 1.5em 40px;
        margin-top: 1em;
        width: 100%;
        height: 100%;

        @media screen and ${constants_1.Device.tablet} {
            flex-direction: column;
            .card-callout-inner-box {
                flex: none;
                width: 100%;
                text-align: left;
            }
        }
    }

    .text-box {
        flex: 6;
    }

    .image-box {
        flex: 4;
        text-align: right;
        img {
            max-height: 200px;
            height: auto;
            width: 100%;
        }
    }
    &.giftcard img {
        margin-top: -8px;
    }

    p,
    h2,
    .posa-help {
        color: white;
    }

    .redeem-link {
        font-size: 1.25em;
        font-weight: 900;
        line-height: 100%;
        text-transform: uppercase;
        margin-bottom: 1em;
        @media screen and ${constants_1.Device.laptopM} {
            font-size: 1em;
        }
    }
`;
//# sourceMappingURL=CardCalloutStyled.js.map